var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"green-text text-darken-1"},[_vm._v("\n        "+_vm._s(_vm.subtitle)+"\n    ")]),_vm._v(" "),_c('span',{staticClass:"habiteo-body-2 grey-text"},[_vm._v("\n        "+_vm._s(_vm.description)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-183fc3bd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myHabiteoStudio/steps/components/StepHeader.vue
// module id = null
// module chunks = 